import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllQuestionSets = (readingId, passage) =>
  apiClient.get(ENDPOINTS.READING.QUESTION_SETS(readingId, passage));

export const getQuestionSetById = (readingId, passage, questionSetId) =>
  apiClient.get(ENDPOINTS.READING.QUESTION_SET(readingId, passage, questionSetId));

export const getAllQuestions = (readingId, passage, questionSetId) =>
  apiClient.get(ENDPOINTS.READING.QUESTIONS(readingId, passage, questionSetId));

export const deleteQuestion = (readingId, passage, questionId) =>
  apiClient.delete(ENDPOINTS.READING.DELETE_QUESTION(readingId, passage, questionId));

export const deleteQuestionSet = (readingId, passage, questionSetId) =>
  apiClient.delete(ENDPOINTS.READING.QUESTION_SET(readingId, passage, questionSetId));

export const getQuestionById = (readingId, passage, questionSetId, questionId) =>
  apiClient.get(ENDPOINTS.READING.QUESTION(readingId, passage, questionSetId, questionId));

export const createQuestion = (readingId, passage, questionSetId, data) =>
  apiClient.post(ENDPOINTS.READING.CREATE_QUESTION(readingId, passage, questionSetId), data);

export const updateQuestion = (readingId, passage, questionSetId, questionId, data) =>
  apiClient.put(ENDPOINTS.READING.UPDATE_QUESTION(readingId, passage, questionSetId, questionId), data);
